/*
 * @Author: LQ
 * @Date: 2022-06-08 08:22:36
 * @LastEditors: LQ
 * @LastEditTime: 2022-09-05 15:31:01
 * @FilePath: \scm-pc\src\official\store\index.js
 * @Description:
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */
import { createStore, createLogger } from 'vuex';

import locale from '@/common/store/modules/locale';
import app from './modules/app';
import navigation from './modules/navigation';
import page from '@/common/store/modules/page';
import user from '@/common/store/modules/user';
import screen from '@/common/store/modules/screen.js';

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  modules: {
    locale,
    app,
    navigation,
    page,
    user,
    screen,
  },
  state: {},
  mutations: {
    set(state, payload) {
      state[payload.k] = payload.v;
    },
  },
  actions: {},
  getters: {},
});
